import posthog from 'posthog-js';

// Flag to track if PostHog has been initialized
let isInitialized = false;

/**
 * Initialize PostHog with the provided API key and options
 * This ensures PostHog is only initialized once
 */
export const initializePostHog = (): void => {
  // Skip if already initialized or if API key is not provided
  if (isInitialized || !import.meta.env.VITE_POSTHOG_API_KEY) {
    return;
  }

  try {
    console.log('Initializing PostHog');
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: false,
      // Disable in development mode
      opt_out_capturing_by_default: import.meta.env.DEV,
    });

    isInitialized = true;
    console.log('PostHog initialized successfully');
  } catch (error) {
    console.error('Failed to initialize PostHog:', error);
  }
};

// Export the PostHog instance for direct access if needed
export { posthog };
